import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, ButtonDropdown, Modal,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import { PIPS_X, SENDPIP4APPROVAL, CANCELIPAAPPROVAL, EMPLOYEES, CONVERT2PA, PIPLINE1, PIPLINE2} from 'helpers/url_helper';
import * as url from "../../helpers/url_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Timeline from './Timeline';
import Swal from 'sweetalert2';
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const ApprovePIPs = () => {
        const {no} = useParams();
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [apType , setApType] = useState(['Annual', 'Probation'])

        const [btnprimary1, setBtnprimary1] = useState(false)
        const [rows1, setrows1] = useState([{ id: 1 }]);
        const [th, setTh] = useState(['Customer','Financial','Internal Business Process','Learning and Growth'])
        const [periods , setPeriods] = useState(['January-June', 'July-December'])
        const [inputs, setInputs] = useState([]);

        const [empNo, setEmpNo] = useState('')
        const [empName, setEmpName] = useState('')
        const [empTitle, setEmpTitle] = useState('')

        const [supervisorNo, setSupervisorNo] = useState('')
        const [supervisorName, setSupervisorName] = useState('')
        const [supervisorTitle, setSupervisorTitle] = useState('')

        const [pipLines1, setPipLines1] = useState([])
        const [pipLines2, setPipLines2] = useState([])

        const [startDate, setStartDate] = useState(new Date());
        const [endDate, setEndDate] = useState(new Date());
        const [type, setType] = useState('');

        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaNo, setIpaNo] = useState('')
        const [ipaStatus, setIpaStatus] = useState('')
        const [ipaDate, setIpaDate] = useState('')
        const [ipaPerformanceYear, setIpaPerformanceYear] = useState('')
        const [ipaConvert, setIpaConvert] = useState('')
        const [pipphase, setPIPPhase] = useState('')
        const [appraisalPeriod, setAppraisalPeriod] = useState('')
        const [documentType, setDocumentType] = useState('')
        const [performanceType, setPerformanceType] = useState('')
        const [departmentCode, setDepartmentCode] = useState('')
        const [stage, setStage] = useState('')
        const [lines, setLines] = useState([])
        const [st, setSt] = useState(0)
        const [isEdit, setIsEdit] = useState(false)
        const [lineSystemId, setLineSystemId] = useState('')
        const [documentid, setDocumentId] = useState('')

        const [kra, setKra] = useState('')
        const [target, setTarget] = useState('')
        const [kpi, setKpi] = useState('')
        const [resources, setResources] = useState('')

        const [cCode, setCCode] = useState('')
        const [competenciesDescription, setCompetenciesDescription] = useState('')
        const [attributes, setAttributes] = useState('')
        const [kpi2, setKpi2] = useState('')
        const [resources2, setResources2] = useState('')
        const [employeeComment, setEmployeeComment] = useState('')
        const [supervisorComment, setSupervisorComment] = useState('')

        const [goal, setGoal] = useState('')
        const [method, setMethod] = useState('')
        const [application, setApplication] = useState('')
        const [competencies, setCompetencies] = useState([])
        const [midYearRemarks, setMidYearRemarks] = useState('')
        const [midYearStatus, setMidYearStatus] = useState(0)
        
        const [modal_ipa1, setmodal_ipa1] = useState(false)
        const [modal_ipa2, setmodal_ipa2] = useState(false)
        const [modal_ipa3, setmodal_ipa3] = useState(false)
        const [modal_ipa4, setmodal_ipa4] = useState(false)

        const [aps, setAps] = useState(0)
        const [abs, setABs] = useState(0)
        const [oaps, setOAps] = useState(0)
        const [oabs, setOABs] = useState('')
        const [whoAmI, setWhoAmI] = useState('')

        const [CompanyID, setCompanyID] = useState("")
        const [showApproveBtn, setShowApproveBtn] = useState(true);
        const [showRejectBtn, setShowRejectBtn] = useState(false);
        const [comment, setComment] = useState('')

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_ipa1 = () => {
            setmodal_ipa1(!modal_ipa1);
            removeBodyCss();
        }
        const tog_ipa2 = () => {
            setmodal_ipa2(!modal_ipa2);
            removeBodyCss();
        }
        const tog_ipa3 = () => {
            setmodal_ipa3(!modal_ipa3);
            removeBodyCss();
        }
        const tog_ipa4 = () => {
            setmodal_ipa4(!modal_ipa4);
            removeBodyCss();
        }
       
        const clearData1 = () =>{
            setIsEdit(false)
            setKra('')
            setTarget('')
            setKpi('')
            setResources('')
            setLineSystemId('')
        }
        const clearData2 = () =>{
            setIsEdit(false)
            setCCode('')
            setAttributes('')
            setKpi2('')
            setResources2('')
            setLineSystemId('')
        }
        const clearData3 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setSupport('')
            setPlannedResults('')
            setActualResults('')
        }
        const clearData4 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setGoal('')
            setMethod('')
            setApplication('')
        }
        const savePA1 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                MidYearRemarks  : midYearRemarks,
                MidYearStatus   : parseInt(midYearStatus)
            }           
            axios.patch(`${PIPLINE1}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Score saved')
                tog_ipa1()
                clearData1()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const savePA2 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                MidYearRemarks  : midYearRemarks,
                MidYearStatus   : parseInt(midYearStatus)
            }            
            axios.patch(`${PIPLINE2}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Score saved')
                tog_ipa2()
                clearData2()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const addIPA1 = () =>{
            setIsloading(true)
            if(isEdit){
                const Config = {
                    auth: {
                      username: url.HRMIS,
                      password: url.HRMISPASS,
                    },
                    headers: {
                      'Content-Type': 'application/json',
                      'If-Match'    : '*'
                    }
                }
                const data = {
                    "KeyResultArea": kra,
                    "StatementofTargettobeachieved": target,
                    "KeyPerformanceIndicator": kpi,
                    "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources
                }           
                axios.patch(`${PIPLINE1}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                    setIsloading(false)
                    toastr.success('PIP line 1 updated')
                    tog_ipa1()
                    clearData1()
                    fetchData()
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }else{
                const data = {
                    "DocumentNo": ipaNo,
                    "KeyResultArea": kra,
                    "StatementofTargettobeachieved": target,
                    "KeyPerformanceIndicator": kpi,
                    "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources
                }           
                axios.post(`${PIPLINE1}?company='${CompanyID}'`, JSON.stringify(data), HRConfig).then((r)=>{
                    setIsloading(false)
                    toastr.success('PIP line 1 added')
                    tog_ipa1()
                    clearData1()
                    fetchData()
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }
            
        }
        const remove1 = ()=>{

            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            axios.delete(`${PIPLINE1}(${lineSystemId})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('PIP line 1 removed')
                tog_ipa1()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const addIPA2 = () =>{
         
            setIsloading(true)
            if(isEdit){
                const Config = {
                    auth: {
                      username: url.HRMIS,
                      password: url.HRMISPASS,
                    },
                    headers: {
                      'Content-Type': 'application/json',
                      'If-Match'    : '*'
                    }
                }
                const data = {
                    "CompetenceCode": cCode,
                    "CriticalAttributestargetedundereachcompetence": attributes,
                    "KeyPerformanceIndicator": kpi2,
                    "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources2
                }           
                axios.patch(`${PIPLINE2}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                    setIsloading(false)
                    toastr.success('PIP line 2 updated')
                    tog_ipa2()
                    clearData2()
                    fetchData()
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }else{
                const data = {
                    "DocumentNo": ipaNo,
                    "CompetenceCode": cCode,
                    "CriticalAttributestargetedundereachcompetence": attributes,
                    "KeyPerformanceIndicator": kpi2,
                    "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources2
                }   
                console.log(JSON.stringify(data)) 
                console.log(`${PIPLINE2}`)       
                axios.post(`${PIPLINE2}?company=${CompanyID}`, JSON.stringify(data), HRConfig).then((r)=>{
                    setIsloading(false)
                    console.log(r)
                    toastr.success('PIP line 2 added')
                    tog_ipa2()
                    clearData2()
                    fetchData()
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }
            
        }
        const handleUpdatePA = () =>{
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "PIPAppraiseeComments": employeeComment,
                "PIPAppraiserComments": supervisorComment,
            }
            setIsloading(true)
            axios.patch(`${url.PIPS_X}(${documentid})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                toastr.success('Appraisal Comments saved')
                setIsloading(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        useEffect(() => {
        fetchData();
        },[]);
        const remove2 = ()=>{
            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            axios.delete(`${PIPLINE2}(${lineSystemId})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('PIP line 2 removed')
                tog_ipa2()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        
        const handleClickLineDetails1 = (k) =>{
            setIsEdit(true)
            tog_ipa1()
            setKra(pipLines1[k].KeyResultArea)
            setTarget(pipLines1[k].StatementofTargettobeachieved)
            setKpi(pipLines1[k].KeyPerformanceIndicator)
            setResources(pipLines1[k].ResourcesandSupportRequiredforachievementsettargetsandgoals)
            setLineSystemId(pipLines1[k].SystemId)
            setMidYearRemarks(pipLines1[k].MidYearRemarks)
            setMidYearStatus(pipLines1[k].MidYearStatus)
        }
        const handleClickLineDetails2 = (k) =>{
            setLineSystemId(pipLines2[k].SystemId)
            setIsEdit(true)
            tog_ipa2()
            setCCode(pipLines2[k].CompetenceCode)
            setAttributes(pipLines2[k].CriticalAttributestargetedundereachcompetence)
            setKpi2(pipLines2[k].KeyPerformanceIndicator)
            setResources2(pipLines2[k].ResourcesandSupportRequiredforachievementsettargetsandgoals)
            setMidYearRemarks(pipLines2[k].MidYearRemarks)
            setMidYearStatus(pipLines2[k].MidYearStatus)
        }
         const reports = [
            {
                icon: "bx bx-copy-alt",
                title: "PIP Competence Score",
                value: aps,
                badgeValue: "",
                color: "success",
                desc: "",
            },
            {
                icon: "bx bx-archive-in",
                title: "PIP Technical Score",
                value: abs,
                badgeValue: "",
                color: "success",
                desc: "",
            },
            {
                icon: "bx bx-copy-alt",
                title: "Overall PIP Assessment",
                value: oaps,
                badgeValue: "",
                color: "success",
                desc: "",
              }
          ];       
        
        const fetchData = () => {
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            let EmployeeNo = obj.uid;
            setCompanyID(obj.activeCompany);
            setIsloading(true)
            axios.get(url.PIPS_X + "?$filter=No eq '"+ no +"'&$expand=pipLines,pipLines2&company="+ obj.activeCompany, HRConfig)
            .then(function(response){
                    axios.get(`${EMPLOYEES}?$filter=No eq '${response.data.value[0].EmployeeNo}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{ 
                        setEmpName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setEmpTitle(r.data.value[0].JobTitle)
                        setIsloading(false)
                    }).catch((e)=>{ console.log(e) })
                    axios.get(`${EMPLOYEES}?$filter=No eq '${response.data.value[0].Appraiser}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{ 
                        setSupervisorName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setSupervisorTitle(r.data.value[0].JobTitle)
                        setIsloading(false)
                    }).catch((e)=>{ console.log(e) })
                    setEmpNo(response.data.value[0].EmployeeNo)
                    
                    setSupervisorNo(response.data.value[0].Appraiser)
                    setDepartmentCode(response.data.value[0].DepartmentCode)
                    setIpaDate(response.data.value[0].PostingDate)
                    setIpaPerformanceYear(response.data.value[0].PerformanceYear)
                    setIpaStatus(response.data.value[0].Status)
                    setIpaConvert(response.data.value[0].ConvertToAppraisal)
                    setAppraisalPeriod(response.data.value[0].AppraisalPeriod)
                    setIpaNo(response.data.value[0].No)
                    setDocumentType(response.data.value[0].DocumentType)
                    setPerformanceType(response.data.value[0].PerformanceType)
                    setStage(response.data.value[0].Stage)
                    setStartDate(response.data.value[0].FromDate)
                    setEndDate(response.data.value[0].ToDate)
                    setType(response.data.value[0].TypeofPerformanceAppraisal)
                    setEmployeeComment(response.data.value[0].employeeComments)
                    setSupervisorComment(response.data.value[0].directSupervisorComments)
                    setPipLines1(response.data.value[0].pipLines)
                    setPipLines2(response.data.value[0].pipLines2)
                    setDocumentId(response.data.value[0].SystemId)
                    setPIPPhase(response.data.value[0].PIPPhase)
                    setAps(response.data.value[0].AverageMidyearCompetencyScore.toFixed(2))
                    setABs(response.data.value[0].AverageMidyearTechnicalScore.toFixed(2))
                    setOAps(response.data.value[0].OverallMidyearAssessment.toFixed(2))
                    setOABs(response.data.value[0].OverallMidyearRemarks)
                    if(response.data.value[0].Status == 'Open'){
                        setSt(5);
                    }else if(response.data.value[0].Status == 'Pending Approval'){
                        setSt(5);
                    }
                   //check who am i
                   //const obj = JSON.parse(localStorage.getItem("authMildUser"));
                   if(response.data.value[0].EmployeeNo == obj.uid){ setWhoAmI('appraisee'); }else if(response.data.value[0].Appraiser == obj.uid){ setWhoAmI('appraiser');  }
                    
                }).catch(function (error) {
                    setUserError(true);
                    setIsloading(false)
                    console.log(error)
                })
                axios.get(url.COMPETENCIES +"?company="+ obj.activeCompany, HRConfig).then((r)=>{ setCompetencies(r.data.value);  }).catch((e)=>{ console.log(e) })
        }
        useEffect(() => {
           fetchData();
        },[]);

        const handleDeleteIPA = () =>{
            Swal.fire({
                title: 'Are you sure?',
                text: 'You will not be able to recover this PIP',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'Cancel',
              }).then((result) => {
                if (result.isConfirmed) {
                    setIsloading(true)
                    const Config = {
                        auth: {
                          username: url.HRMIS,
                          password: url.HRMISPASS,
                        },
                        headers: {
                          'Content-Type': 'application/json',
                          'If-Match'    : '*'
                        }
                    }
                    axios.delete(`${PIPS_X}(${id})?company=${CompanyID}`, Config).then((r)=>{
                        setIsloading(false)
                        Swal.fire('Deleted!', 'PIP has been deleted.', 'success');
                        history.push("/performance-improvement-plans")
                    }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                    })
                  
                }
              });
            
        }

        const handleSendForApproval = () => {
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(SENDPIP4APPROVAL+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success(response.data.value ); 
                        fetchData()
                    }else{
                        toastr.success("Could not Post PIP" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                })
                .then(function () {
                // always executed
                setIsloading(false)
            });
        }
        const handleCancelApproval = () => {
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(CANCELIPAAPPROVAL+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){      
                    if(response.status == '200'){
                        toastr.success(response.data.value); 
                        fetchData()
                    }else{
                        toastr.success("Could not Cancel Approval Request" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }
        const handleActionChange = () =>{
            const selectedAction = document.getElementsByClassName('lAction')[0].value;
            if(selectedAction == 'APPROVE'){
                setShowApproveBtn(true)
                setShowRejectBtn(false)
            }else if(selectedAction == 'REJECT'){
                setShowApproveBtn(false)
                setShowRejectBtn(true)
            }
        }
        const handleApproveIpa = () =>{
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(url.APPROVENFLREQUEST +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success("Performance Improvement Plan Approved" );
                        history.push(`/approvals/`) 
                    }else{
                        toastr.success("Could not Approve Performance Improvement Plan" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
                })
        }
        const handleRejectIpa = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo, "rejectioncomment":comment}
            axios.post(url.REJECT_LR+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    if(response.status == '200'){
                        toastr.success("Performance Improvement Plan rejected");
                        history.push(`/rejected/${ipaNo}`) 
                    }else{
                        toastr.success("Could not reject Performance Improvement Plan" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    console.log(error)
                    setIsloading(false)
            })  
        }


        const handleConverToAppraisal = () =>{
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(CONVERT2PA +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){  
                    //console.log(response)  
                    if(response.status == '204'){
                        toastr.success(response.data.value); 
                        history.push("/performance-appraisals");
                    }else{
                        toastr.success("Could not Convert To Performance Appraisal" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
            });
        }

        const handleFillAppraisal = () =>{
            history.push("/performance-appraisals");
        }


        const [formRows, setFormRows] = useState([{ id: 1 }]);

        return (
            <LoadingOverlay
            active={isloading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
            <MetaTags>
            <title>PIP Details | BRIDGE</title>
            </MetaTags>
            <Container fluid={true}>
                <Breadcrumbs title="Performance Management" breadcrumbItem="Performance Improvement Plans" />
                <div>


                            <Modal isOpen={modal_ipa1} toggle={tog_ipa1} size='xl' centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update `:`Add `} Technical Job Deliverables</h5>
                                    <button type="button" onClick={() => { setmodal_ipa1(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Result Area</label>
                                                <textarea rows={3} className="form-control" value={kra} onChange={(e)=>setKra(e.target.value)} disabled = {true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Statement of target to be achieved</label>
                                                <textarea rows={3} className="form-control" value={target} onChange={(e)=>setTarget(e.target.value)} disabled = {true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea rows={3} className="form-control" value={kpi} onChange={(e)=>setKpi(e.target.value)} disabled = {true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Resources Required</label>
                                                <textarea rows={3} className="form-control" value={resources} onChange={(e)=>setResources(e.target.value)} disabled = {true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>PIP Remarks</label>
                                                <textarea rows={3} className="form-control" value={midYearRemarks} onChange={(e)=>setMidYearRemarks(e.target.value)} />
                                            </div>
                                        </Col>
                                        {/* <Col md={12}>
                                            <div className="mb-3">
                                                <label>PIP Score</label>
                                                <input type='number' className="form-control" value={midYearStatus} onChange={(e)=>setMidYearStatus(e.target.value)} />
                                            </div>
                                        </Col> */}
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_ipa1() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={savePA1}>Save Score...</button>
                                  </div>
                                  )}
                                </Modal>
                                <Modal isOpen={modal_ipa2} toggle={tog_ipa2} size='xl' centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update `:`Add `} Competence Targets</h5>
                                    <button type="button" onClick={() => { setmodal_ipa2(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Competence Code</label>
                                                <select className="form-select" value={cCode} onChange={(e)=>setCCode(e.target.value)} disabled={true}>
                                                    <option value=""></option>
                                                    {competencies.map((c,k)=>(
                                                        <option key={k} value={c.code}>{c.codeDescription}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        {/*<Col md={12}>
                                            <div className="mb-3">
                                                <label>Description</label>
                                                <textarea className="form-control" value={competenciesDescription} onChange={(e)=>setCompetenciesDescription(e.target.value)} />
                                            </div>
                                        </Col>*/}
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Critical Attributes Targeted</label>
                                                <textarea rows={3} className="form-control" value={attributes} onChange={(e)=>setAttributes(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div rows={3} className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea rows={3} className="form-control" value={kpi2} onChange={(e)=>setKpi2(e.target.value)} disabled = {true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div rows={3} className="mb-3">
                                                <label>Resources Required</label>
                                                <textarea rows={3} className="form-control" value={resources2} onChange={(e)=>setResources2(e.target.value)} disabled = {true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div rows={3} className="mb-3">
                                                <label>PIP Remarks</label>
                                                <textarea rows={3} className="form-control" value={midYearRemarks} onChange={(e)=>setMidYearRemarks(e.target.value)} />
                                            </div>
                                        </Col>
                                        {/* <Col md={12}>
                                            <div className="mb-3">
                                                <label>PIP Score</label>
                                                <input type='number' className="form-control" value={midYearStatus} onChange={(e)=>setMidYearStatus(e.target.value)} />
                                            </div>
                                        </Col> */}
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_ipa2() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={savePA2}>Save Score...</button>
                                  </div>
                                  )}
                                </Modal>
                
                <Row>
                <Col  xl={3}>
                            <Timeline stage={st}/>
                            {(ipaStatus == 'Open') && (
                                <Card>
                                    <CardBody>
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Performance Improvement Plan Actions</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                        <div className="d-grid">
                  
                                            <ButtonDropdown
                                                isOpen={btnprimary1}
                                                toggle={() => setBtnprimary1(!btnprimary1)}
                                                >
                                                <DropdownToggle tag="button" className="btn btn-primary">
                                                    + Add Deliverables <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                
                                                <DropdownMenu>
                                                    <DropdownItem onClick={()=>{ tog_ipa1(); clearData1();}}>Add Technical Job Deliverables</DropdownItem>
                                                    <DropdownItem onClick={()=>{ tog_ipa2(); clearData2();}}>Add Competence Targets</DropdownItem> 
                                                </DropdownMenu>
                                            
                                            </ButtonDropdown>
                                            </div>
                                        </Col>
                                    </Row>
                                    </CardBody>
                                </Card>
                            )}

                        </Col>
                        <Col xl={9}>
                        <Card>
                            <CardBody>
                            <Row>
                                <Col sm={12}>
                                    <h5 className="text-primary">Details</h5>
                                        <hr/>
                                </Col>
                            </Row>
                       
                                    <Row>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee No</label>
                                            <input type="text" className="form-control" disabled={true}  defaultValue = {empNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empName} />
                                        </div>
                                    </Col>
                                   
                              
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorName} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorTitle}  />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                            <Row>
                                <Col sm={12}>
                                    <h5 className="text-primary">PIP Details</h5>
                                        <hr/>
                                </Col>
                            </Row>
                                <Row>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>No</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaNo}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Department Code</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={departmentCode}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Performance Type</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={performanceType}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Performance Year</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaPerformanceYear}  />
                                        </div>
                                </Col>
                                {<Col md={4}>
                                        <div className="mb-3">
                                            <label>PIP Stage</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={pipphase}  />
                                        </div>
                                </Col>}
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaStatus}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Posting Date</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaDate}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Start Date</label>
                                        <Flatpickr
                                            className="form-control"
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                disabled: true
                                            }}
                                            value={new Date(startDate)}
                                            onChange={(date)=>setStartDate(date)}
                                        />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>End Date</label>
                                        <Flatpickr
                                            className="form-control"
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                disabled: true
                                            }}
                                            value={new Date(endDate)}
                                            onChange={(date)=>setEndDate(date)}
                                        />
                                        </div>
                                    </Col>
                                    
                                    </Row>
                                
                             
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Technical Job Deliverables ({pipLines1.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(pipLines1.map((i,k)=>(
                                        <Row key={k} className='justify-content-center align-items-center'>
                                            <Col lg={7}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Result Area: </strong><br/>{i.KeyResultArea}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Statement of target to be achieved: </strong><br/>{i.StatementofTargettobeachieved} 
                                                    </p>
                                                    <p className="mb-1">
                                                    <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Performance Indicator: </strong><br/>{i.KeyPerformanceIndicator}
                                                    </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={5} className="mb-3">
                                                
                                                <p className="mb-1">
                                                    <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Resources and support required: </strong><br/>{i.ResourcesandSupportRequiredforachievementsettargetsandgoals}
                                                </p>
                                                <h5>&nbsp;</h5>
                                            {(pipphase == 'PIP Performance Review') && (ipaStatus == 'Pending Approval') && ( 
                                            <Row className='justify-content-center'>
                                                <Col>
                                                    <div className="align-items-center">   
                                                        <Button
                                                            type="button"
                                                            color="info"
                                                            className="btn-sm btn-rounded m-3"
                                                            onClick={()=>handleClickLineDetails1(k)}
                                                            >
                                                            Appraiser ratings
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Row  className="m-1 mb-4">
                                                  <Col sm={12}><h5 className="text-primary">PIP remark:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                               </Row>
                                               {/* <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">PIP Score</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                               </Row> */}
                                            </Row>
                                            )}  
                                        </Col>
                                        <hr/>
                                        </Row>
                                    )))}
                          
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Competence Targets ({pipLines2.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(pipLines2.map((i,k)=>(
                                        <Row key={k} className='justify-content-center align-items-center'>
                                            <Col lg={7}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Competence Code: </strong><br/>{i.CompetenceCode} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Description: </strong><br/>{i.competenciesDescription} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Critical Attributes Targeted: </strong><br/>{i.CriticalAttributestargetedundereachcompetence}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Performance Indicator: </strong><br/>{i.KeyPerformanceIndicator}
                                                    </p>                                                
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={5} className="mb-3">
                                            
                                          <h5>&nbsp;</h5>
                                          <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Resources and support required: </strong><br/>{i.ResourcesandSupportRequiredforachievementsettargetsandgoals}
                                                    </p>
                                              {(pipphase == 'PIP Performance Review') && (ipaStatus == 'Pending Approval') && ( 
                                            <Row className='justify-content-center'>
                                                <Col>
                                                    <div className="align-items-center">   
                                                        <Button
                                                            type="button"
                                                            color="info"
                                                            className="btn-sm btn-rounded m-3"
                                                            onClick={()=>handleClickLineDetails2(k)}
                                                            >
                                                            Appraiser ratings
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Row  className="m-1 mb-4">
                                                  <Col sm={12}><h5 className="text-primary">PIP remark:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                               </Row>
                                               {/* <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">PIP Score</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                               </Row> */}
                                               
                                            </Row>
                                               )}
                                          </Col>
                                          <hr/>
                                        </Row>
                                    )))}
                                    </CardBody>
                                    </Card>

                                    {/* <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Key Reflection Questions</h5>
                                    <CardBody>
                                    {(pipphase == 'PIP Performance Review') && (
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Employee/Appraisee comment</label>
                                            <textarea rows={4} className="form-control" value={employeeComment} onChange={(e)=>setEmployeeComment(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Supervisor/Appraiser comment</label>
                                            <textarea rows={4} className="form-control" value={supervisorComment} onChange={(e)=>setSupervisorComment(e.target.value)}  />
                                            </div>
                                        </Col>
                                    </Row>
                                    )}
                                    {(pipphase == 'PIP Performance Review') && (whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && (
                                    <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="warning"
                                                        className="btn btn-rounded"
                                                        onClick={handleUpdatePA}
                                                        >
                                                        Save key reflection responses
                                                    </Button>
                                                </div>
                                            </Col>
                                    </Row>
                                    )}
                                    </CardBody>
                                    </Card>  */}

                                    </Col>
                    
                                <Col md={3}></Col>
                                <Col md={9}>
                                <Row className='justify-content-center align-items-center'>
                                    <Col md={5} className='mb-3'>
                                        <div className="d-grid gap-2">
                                        {(ipaStatus == 'Open') && (
                                            <input
                                                type="button"
                                                className="btn btn-success mt-3 mt-lg-0"
                                                value="Send For Approval"
                                                onClick={handleSendForApproval}
                                            />
                                        ) }
                                        </div>
                                    </Col>
                                    
                                    {(ipaStatus == 'Open') && (
                                        <Col md={5} className='mb-3'>
                                        <div className="d-grid gap-2">
                                            <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={handleDeleteIPA} >
                                                Delete PIP
                                            </Button>
                                        </div>
                                        </Col>
                                    ) }
                                    
                                    </Row>

                                    <Row className='justify-content-center align-items-center'>
                                    <Col md={5} className='mb-3'>
                                    {((ipaStatus == 'Approved') && (ipaConvert == 'No')) && (
                                        <div className="d-grid gap-2">
                                            <Button color="warning" type="button" className="btn" onClick={handleConverToAppraisal} >
                                                Convert to Performance Appraisal
                                            </Button>
                                        </div>
                                    ) }
                                    {((ipaStatus == 'Approved') && (ipaConvert == 'Yes')) && (
                                        <div className="d-grid gap-2">
                                            <Button color="secondary" type="button" className="btn" onClick={handleFillAppraisal} >
                                                Fill Performance Appraisal Form
                                            </Button>
                                        </div>
                                    ) }
                                    </Col>
                                    </Row>
                                    {/* {(pipphase == 'PIP Performance Review') && (
                                    <Row  className="justify-content-center">
                                        {reports.map((report, key)=>(  
                                        <Col sm="4" key={key}>
                                        <Card>
                                            <CardBody>
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="avatar-xs me-3">
                                                <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                                                    <i className={report.icon} />
                                                </span>
                                                </div>
                                                <h5 className="font-size-14 mb-0">{report.title}</h5>
                                            </div>
                                            <div className="text-muted mt-4">
                                                <h4>
                                                {report.value}{" "}
                                                <i className="mdi mdi-chevron-up ms-1 text-success" />
                                                </h4>
                                            
                                            </div>
                                            </CardBody>
                                        </Card>
                                        </Col>
                                        ))} 
                                    </Row>
                                    )} */}
                                    {(ipaStatus == 'Pending Approval') && (
                                    <>
                                        <Row>
                                        <Col md={12}>
                                                    <div className="form-floating mb-3">
                                                        <select  className="form-select lAction" onChange={handleActionChange}>
                                                            
                                                            <option value="APPROVE">APPROVE PERF. IMPROVEMENT PLAN</option>
                                                            <option value="REJECT">REJECT PERF. IMPROVEMENT PLAN</option>
                                    
                                                        </select>
                                                        <label htmlFor="floatingSelectGrid"> Select Action</label>
                                                    </div>
                                                </Col>
                                        </Row>
                                        {showRejectBtn && (
                                                <Row>
                                                <Col md={12}>
                                                    <div className="form-floating mb-3">
                                                        <input  type="text" className="form-control" onChange={(e)=>setComment(e.target.value)}  />
                                                        <label htmlFor="floatingSelectGrid"> Rejection Comment</label>
                                                    </div>
                                                </Col>
                                                </Row>
                                            )}
                                        <Row className=' justify-content-center align-items-center'>
                                                {showRejectBtn && (
                                                <Col md={6} className="reject">
                                                    <div className="d-grid gap-2">
                                                        <Button color="danger" type="button" className="btn btnRejectRequest" onClick={handleRejectIpa}>
                                                            Reject
                                                        </Button>
                                                    </div>
                                                </Col>
                                                )}
                                                {showApproveBtn && (
                                                <Col md={6} className="approve">
                                                    <div className="d-grid gap-2">
                                                        <Button color="success" type="button" className="btn btnApproveRequest" onClick={handleApproveIpa}>
                                                            Approve 
                                                        </Button>
                                                    </div>
                                                </Col>
                                                )}
                                            </Row>
                                    </>)}

                                    
      
                                   
            
                </Col>
                </Row>

                </div>              
                   

            </Container>
        </div>
        </LoadingOverlay>
        );
    }

export default ApprovePIPs;